// extracted by mini-css-extract-plugin
module.exports = {"video":"video-module--video--3p1JG"};